import type { ObraTipo } from "@/modules/recursos";
/** Datas do contrato: strings `YYYY-MM-DD`, tratadas sempre sem fuso. */
export type IsoDate = string;

export interface CargaTrabalhoIntervalo {
  inicio: IsoDate;
  fim: IsoDate;
}

export type CargaTrabalhoPeriodo = CargaTrabalhoIntervalo;

export interface CargaTrabalhoEtapas {
  planejamento: CargaTrabalhoIntervalo | null;
  obra: CargaTrabalhoIntervalo | null;
  fechamento: CargaTrabalhoIntervalo | null;
}

export interface CargaTrabalhoObra {
  id: string;
  codigo: string;
  nome: string;
  situacao: string;
  embarcacao: { id: string; nome: string; acronimo?: string | null } | null;
  etapas: CargaTrabalhoEtapas;
}

export interface CargaTrabalhoAlocacao {
  id: string;
  papelObraId: string | null;
  inicio: IsoDate;
  fim: IsoDate;
  obra: CargaTrabalhoObra;
}

/** Conflito mantido com justificativa (HU 2434, RN07): identificado pelas alocações envolvidas. */
export interface CargaTrabalhoConflitoIgnorado {
  alocacaoIds: string[];
}

export interface CargaTrabalhoProfissional {
  id: string;
  nome: string;
  time: string | null;
  alocacoes: CargaTrabalhoAlocacao[];
  indisponibilidades: CargaTrabalhoIntervalo[];
  /** Conflitos já tratados como "Ignorar Conflito"; ausente quando o bff não informa. */
  conflitosIgnorados?: CargaTrabalhoConflitoIgnorado[];
}

export interface CargaTrabalhoProfissionaisData {
  periodo: CargaTrabalhoPeriodo;
  profissionais: CargaTrabalhoProfissional[];
}

export interface CargaTrabalhoObraProfissional {
  /** Id do usuário. */
  id: string;
  /** Id da alocação na obra; ausente quando o bff não informa. */
  alocacaoId?: string;
  nome: string;
  time: string | null;
  papelObraId: string | null;
  inicio: IsoDate;
  fim: IsoDate;
}

export interface CargaTrabalhoObraComEquipe extends CargaTrabalhoObra {
  /** Tipos da obra, por código; vazio em dados antigos. */
  tipos?: ObraTipo[];
  profissionais: CargaTrabalhoObraProfissional[];
  /**
   * Conflitos ignorados (RN07) que envolvem alguma alocação da obra, repetidos em cada obra
   * do conflito; ausente quando o bff não informa.
   */
  conflitosIgnorados?: CargaTrabalhoConflitoIgnorado[];
}

export interface CargaTrabalhoObrasData {
  periodo: CargaTrabalhoPeriodo;
  obras: CargaTrabalhoObraComEquipe[];
}

export type CargaTrabalhoAgrupamento = "profissionais" | "obras";

export interface CargaTrabalhoFilters {
  busca: string;
  obraId: string;
  embarcacaoId: string;
  situacao: string;
}

export const EMPTY_CARGA_TRABALHO_FILTERS: CargaTrabalhoFilters = {
  busca: "",
  obraId: "",
  embarcacaoId: "",
  situacao: "",
};

export interface ListCargaTrabalhoParams {
  periodo: CargaTrabalhoPeriodo;
  filters?: Partial<CargaTrabalhoFilters>;
  /** Restringe aos profissionais da equipe em criação/edição (HU 2059). */
  profissionalIds?: string[];
  signal?: AbortSignal;
}

export type CargaTrabalhoStatus = "loading" | "success" | "error" | "forbidden";

export interface CargaTrabalhoQueryState<T> {
  status: CargaTrabalhoStatus;
  data: T | null;
  errorMessage: string | null;
}
